<template>
  <div class="skeleton-detail-container" @touchmove.prevent>
    <div class="skeleton-header flex-start">
      <div class="skeleton-logo skeleton-animation" />
      <div class="flex-column skeleton-header-info">
        <div class="skeleton-animation skeleton-title" />
        <div class="skeleton-animation skeleton-info" />
      </div>
    </div>
    <div class="skeleton-detail-block">
      <div class="flex-between">
        <div class="skeleton-block-title skeleton-animation" />
        <div class="skeleton-btn skeleton-animation" />
      </div>
      <div class="link-line skeleton-animation" />
      <div class="link-line link-line-two skeleton-animation" />
    </div>
    <div class="skeleton-detail-block">
      <div class="skeleton-block-title skeleton-animation" />
      <div class="skeleton-line margin-10 skeleton-animation" />
      <div class="skeleton-line margin-10 skeleton-animation" />
      <div class="skeleton-line skeleton-animation" />
    </div>
    <div class="skeleton-detail-block">
      <div class="skeleton-block-title skeleton-animation" />
      <div class="skeleton-line skeleton-animation" />
    </div>
    <div class="skeleton-detail-block">
      <div class="skeleton-block-title skeleton-animation" />
      <div class="skeleton-desc skeleton-animation" />
    </div>
  </div>
</template>

<script>
  export default {
    name: 'skeleton-detail',
    data() {
      return {}
    },
    mounted() {
    },
    computed: {},
    watch: {},
    components: {},
    methods: {}
  }
</script>

<style lang="scss" scoped>
  .skeleton-detail-container {
    padding: 4px 16px 0;
    border-top: 8px solid #F9F9F9;
    * {
      border-radius: 4px;
    }
    .skeleton-header {
      padding: 16px 0;
      border-bottom: 1px solid #F9F9F9;
      .skeleton-logo {
        width: 40px;
        height: 40px;
        border-radius: 6px;
        margin-right: 10px;
      }
      .skeleton-header-info {
        flex-shrink: 1;
      }
      .skeleton-title {
        height: 20px;
        width: 240px;
      }
      .skeleton-info {
        height: 15px;
        width: 180px;
        margin-top: 6px;
      }
    }
    .skeleton-detail-block {
      padding: 15px 0;
      .skeleton-block-title {
        width: 72px;
        height: 25px;
        margin-bottom: 12px;
      }
      .skeleton-btn {
        width: 52px;
        height: 25px;
      }
      .link-line {
        height: 16px;
        width: 100%;
        margin-bottom: 8px;
      }
      .link-line-two {
        width: 225px;
      }
      .skeleton-line {
        height: 40px;
      }
      .skeleton-desc {
        height: 430px;
      }
      .margin-10 {
        margin-bottom: 10px;
      }
    }
  }
</style>